import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Radium from 'radium';
import ChevronRight from '@material-ui/icons/ChevronRight';
import { UTLabel, UTTouchableWithoutFeedback } from '@widergy/energy-ui';

import styles from './styles';

class UTListItem extends PureComponent {
  handleClick = () => this.props.onClick && this.props.onClick(this.props.item);

  createIcon = icon =>
    typeof icon === 'string' ? (
      <img src={icon} style={styles.icon} alt="" />
    ) : (
      <UTLabel style={styles.iconContainer}>{icon}</UTLabel>
    );

  render() {
    const { onClick, item } = this.props;
    const styleVar = !onClick ? styles.noClick : {};
    return (
      <UTTouchableWithoutFeedback style={{ ...styles.container, ...styleVar }} onClick={this.handleClick}>
        <div style={styles.textContainer}>
          {item.icon && this.createIcon(item.icon)}
          <div style={styles.text}>
            <UTLabel semibold style={styles.label}>
              {item.title}
            </UTLabel>
            {item.subtitle && (
              <UTLabel small ligth darkGray style={styles.label}>
                {item.subtitle}
              </UTLabel>
            )}
          </div>
        </div>
        {item.rightButton || (onClick && <ChevronRight />)}
      </UTTouchableWithoutFeedback>
    );
  }
}

UTListItem.propTypes = {
  item: PropTypes.shape({
    id: PropTypes.number.isRequired,
    icon: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    title: PropTypes.string.isRequired,
    subtitle: PropTypes.string,
    rightButton: PropTypes.node
  }),
  onClick: PropTypes.func
};

export default Radium(UTListItem);
